import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActionTypes';
import actionTypesAuth from '../Auth/ActionTypes';
import InitState from './InitState';

export default (state = InitState, actions) => {
  switch (actions.type) {
    case actionTypesAuth.LOGOUT.fulfilled:
      return {...InitState};

    case actionTypes.GET_USER_DATA_FOR_EDIT:
      return {...state, dataForEdit: actions.data};

    case actionTypes.OFF_SUCCESS_UPDATE:
      return {...state, successUpdated: false};

    case actionTypes.CHANGED_INPUT_DATA:
      return {...state, dataForEdit: {...state.dataForEdit, [actions.data.field]: actions.data.value}};

    case actionTypes.EDIT_PROFILE.pending:
      return {...state, promise: {...state.promise, editProfile: {...setPromiseState(true, false, false)}}};
    case actionTypes.EDIT_PROFILE.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, editProfile: {...setPromiseState(false, false, true)}}};
    case actionTypes.EDIT_PROFILE.fulfilled: {
      return {...state, error: {}, successUpdated: true, promise: {...state.promise, editProfile: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.TOGGLE_IS_SHOW_CHANGE_EMAIL_MODAL:
      return {...state, isOpenModalChangeEmail: !state.isOpenModalChangeEmail};

    case actionTypes.EDIT_USER_EMAIL.pending:
      return {...state, error: {}, promise: {...state.promise, editEmail: {...setPromiseState(true, false, false)}}};
    case actionTypes.EDIT_USER_EMAIL.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, editEmail: {...setPromiseState(false, false, true)}}};
    case actionTypes.EDIT_USER_EMAIL.fulfilled: {
      return {...state, error: {}, isOpenModalChangeEmail: false, promise: {...state.promise, editEmail: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.TOGGLE_IS_SHOW_CHANGE_PASSWORD_MODAL:
      return {...state, isOpenModalChangePassword: !state.isOpenModalChangePassword};

    case actionTypes.EDIT_USER_PASSWORD.pending:
      return {...state, error: {}, promise: {...state.promise, editPassword: {...setPromiseState(true, false, false)}}};
    case actionTypes.EDIT_USER_PASSWORD.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, editPassword: {...setPromiseState(false, false, true)}}};
    case actionTypes.EDIT_USER_PASSWORD.fulfilled: {
      return {...state, error: {}, isOpenModalChangePassword: false, promise: {...state.promise, editPassword: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.TOGGLE_IS_SHOW_DELETE_USER_ACCOUNT:
      return {...state, isOpenModalDeleteAccount: !state.isOpenModalDeleteAccount};

    case actionTypes.DELETE_USER_ACCOUNT.pending:
      return {...state, error: {}, promise: {...state.promise, deleteAccount: {...setPromiseState(true, false, false)}}};
    case actionTypes.DELETE_USER_ACCOUNT.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, deleteAccount: {...setPromiseState(false, false, true)}}};
    case actionTypes.DELETE_USER_ACCOUNT.fulfilled: {
      return {...InitState};
    }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Profile/Reducer.js